<template lang="pug">
div.view_container
  Header(v-on:is-small-screen="setIsSmallScreen")
  div.view_title
    span You're done!
  div.section(v-show="!isSignedIn && currentProject && participantSlug")
    div.title Know anyone else who should do a video?
    div(v-if="showInvite")
      div.input_container
        input(v-model="name" type="text" placeholder="Enter their name")
      div.input_container
        input(v-model="email" type="text" placeholder="Enter their email and hit enter" v-on:keyup="keyEnterToSubmit")
      br
    div.controls
      button.cta(v-on:click="invitePeople" ref="invite" style="touch-action: manipulation") {{ inviteButtonTitle }}
      button.done.google_logo(v-show="showImportAddress && showGoogleSignIn" v-on:click="googleSignIn" v-bind:class="{small_screen:isSmallScreen}") Select from address book
      button.done(v-show="!showImportAddress" v-on:click="showInvite=!showInvite" v-bind:class="{small_screen:isSmallScreen}") {{ toggleEmailSelectTitle }}
    div.contact_list_container(v-if="contactsWithSelectedState &&  !showInvite")
      div.input_container
        input(v-model="searchText" type="text" placeholder="Search your address book"  ref="searchText")
      div.loading(v-if="$apollo.loading || loading")
        img(v-bind:src="loadingSrc")
      div.selected_list(v-if="selectedContacts.length > 0")
        span.label selected: &nbsp;&nbsp;
        span(v-for="(contact,index) in selectedContacts")
          span(v-if="index!=0") ,&nbsp;
          a.clickable(v-on:click="toggleSelectedContact(contact)") {{contact.firstName}} {{contact.lastName}}
      div.list
        div(v-for="(contact,index) in contactsWithSelectedState")
          div.contact(v-if="!contact.selected" v-bind:class="{active: !contact.invited}" v-on:click="toggleSelectedContact(contact)")
            div.name
              span {{contact.firstName}}&nbsp;{{contact.lastName}}
              span.invited(v-if="contact.invited") &nbsp;&nbsp;&nbsp;already invited
            div.email {{contact.email}}
  div.section(v-show="isSignedIn")
    div.description We'll let you know when people do their videos.
    br
    br
    button(v-on:click="next('/create')") Create another video
    br
    br
    button(v-on:click="next('/')") See your current videos

</template>

<script>
import { INVITE_PEOPLE_WITH_PARTICIPANT_SLUG_MUTATION } from '../graphql/mutations'
import { GET_PARTICIPANT_FROM_SLUG_QUERY,GET_CONTACTS_FROM_SLUG_QUERY } from '../graphql/queries'

import Header from '../components/Header'

export default {
  name: 'Done',
  props: {

  },
  components: {
    Header,
  },
  computed: {
    loadingSrc () {
      return process.env.BASE_URL + "loading_dark.gif"
    },
    toggleEmailSelectTitle () {
      if (!this.showInvite) {
        return 'Type in an email address'
      }
      return 'Show address book'
    },
    isSignedIn () {
      return this.$store.getters.signedIn
    },
    currentProject () {
      return this.$store.state.currentProject
    },
    currentUser () {
      return this.$store.state.user.user
    },
    participantSlug () {
      return this.$store.state.participantSlug
    },
    inviteButtonTitle () {
      return this.loading ? "Sending invite..." : "Invite"
    },
    currentProjectSlug () {
      return this.participant.project.slug
    },
    showImportAddress () {
      if (this.contacts && this.contacts.length > 0) return false
      return true
    },
    contactsWithSelectedState () {
      if (!this.contacts) return null
      return this.contacts.map((contact) =>
        Object.assign(contact, {invited:
        this.participants.findIndex((p) => p.email == contact.email) >= 0,
        selected: this.selectedContacts.findIndex((p) => p.email == contact.email) >= 0
        })
    )
    },
    selectedContactsForAdding () {
      return this.selectedContacts.map((c)=> {
        return {
          name: (c.firstName != null ? c.firstName : "") + " " + (c.lastName != null ? c.lastName : ""),
          email: c.email
        }
      })
    },
  },
  data () {
    return {
      isSmallScreen: false,
      name: null,
      email: null,
      loading: false,
      participants: [],
      contacts: null,
      showInvite: true,
      searchText: null,
      authCode: null,
      selectedContacts: [],
      showGoogleSignIn: process.env.VUE_APP_SHOW_GOOGLE_SIGNIN,
    }
  },
  apollo: {
    participant () {
      return {
        query: GET_PARTICIPANT_FROM_SLUG_QUERY,
        variables () {
          return {
           slug: this.participantSlug
          }
        },
        skip () {
          return !this.participantSlug
        },
        fetchPolicy: 'cache-and-network',
      }
    },
    contacts () {
      return {
        // gql query
        query: GET_CONTACTS_FROM_SLUG_QUERY,
        variables () {
          return {
            searchText: this.searchText,
            authCode: this.authCode,
            participantSlug: this.participantSlug,
          }
        },
        update: data => {
          if (data.contacts && data.contacts.length > 0) this.showInvite = false
          return data.contacts
        },
        error: (error) => {
          console.log(error.message)
        },
        skip () {
          return !this.participantSlug
        },
        fetchPolicy: 'network-only',
      }
    },
  },
  methods: {
    keyEnterToSubmit: function (e) {
      if (e.keyCode === 13) {
        this.invitePeople()
      }
    },
    setIsSmallScreen: function(isSmall) {
      this.isSmallScreen = isSmall
    },
    toggleSelectedContact: function(contact) {
      if (contact.invited) return

      const index = this.selectedContacts.findIndex((c) => c.email == contact.email )
      if (index >= 0) {
        this.selectedContacts.splice(index,1)
      } else {
        this.selectedContacts.push(contact)
      }
    },
    googleSignIn: async function () {
      this.authCode = await this.$gAuth.getAuthCode()
    },
    next: function (name) {
      if (name.match(/create/)) { this.$store.commit('clearProject') }
      this.$router.push(name)
    },
    invitePeople: async function() {
      const contacts = this.selectedContactsForAdding
      if (this.name && this.email) contacts.push({
        name: this.name,
        email: this.email,
      })

      if (contacts.length <= 0) {
        this.$toast.error('Please enter or select emails to invite.')
        return
      }

      this.loading = true
      this.$apollo.mutate({
        mutation: INVITE_PEOPLE_WITH_PARTICIPANT_SLUG_MUTATION,
        variables: {
          participantSlug: this.participantSlug,
          participants: contacts,
        },
      }).then((data) => {
        this.loading = false
        const errors = data.data.addParticipantsWithParticipantSlug.errors
        const participants = data.data.addParticipantsWithParticipantSlug.participants
        // console.log(data)
        if (participants && participants.length > 0) {
          this.participants = this.participants.concat(participants)
          this.$toast.success('Successfully invited: '+participants.map((p) => p.email).join(','))
          this.name = null
          this.email = null
        } else {
          this.participants = this.participants.concat(this.selectedContacts)
          this.$toast.error("There was a problem with the emails you tried to invite. They may have already been invited.")
        }
        this.selectedContacts = []
        this.errorsToast(errors)
      }).catch((error) => {
        this.loading = false
        console.error(error)
        this.errorToast(error)
      })
    },
  },
  mounted: function() {
    window.vue = this
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.title {
  font-family: gibsonsemibold;
  font-size: 26px;
  color: #151516;
  margin-bottom: 10px;
}
.description {
  font-size: 20px;
  color: #74747c;
}
.section {
  margin-top: 30px;
}

button.cta {
  font-size: 20px;
}

button.done {
  font-size: 20px;
  margin: 0px 0px 0px 20px;
  padding: 20px 44px;
  border-radius: 35px;
  -webkit-border-radius: 35px;
  -moz-border-radius: 35px;
}

button.small_screen {
  width: 90%;
  margin: 0px 0px 20px 0px;
}

.list {
  max-height: 600px;
  overflow-y: scroll;
  border: 1px solid #F5F5F6;
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;

  font-family: gibsonregular;
  font-size: 18px;
}

.selected_list {
  padding: 20px 4%;
  font-family: gibsonsemibold;
}
.label {
  font-size: 18px;
}

.name {
  font-family: gibsonsemibold;
}

.active .name {
  color: #000000;
}

.contact div {
  display: inline-block;
}

.email {
  float: right;
}

a {
  color: #6f63bd;
}

.contact {
  padding: 20px 4%;
  border-bottom: 1px solid #F5F5F6;
  background-color: #f8f8f8;
}

.list .active {
  cursor: pointer;
  background-color: #ffffff;
}

.list .active:hover {
  background-color: #f8f8f8;
}

.invited {
  font-family: gibsonregular;
}

.controls {
  margin: 20px 0px;
}

</style>
